"use client";

import { useTranslations } from "next-intl";
import { cloneElement, type ReactElement, type ReactNode } from "react";

type TransProps = {
  i18nKey: string;
  components?: ReactElement[] & { length: 1 | 2 | 3 };
};

const IdxToLetterMap = {
  0: "A",
  1: "B",
  2: "C"
} as const;

export function Trans({ i18nKey, components }: TransProps) {
  const t = useTranslations();

  if (!components) {
    return t(i18nKey);
  }

  const customTags = components.reduce((acc, curr, i) => {
    const CurComponent = curr;
    return {
      ...acc,
      [IdxToLetterMap[i as 0 | 1 | 2]]: (chunks: ReactNode) =>
        // <br> tag can't take children
        CurComponent.type === "br" ? (
          <br />
        ) : (
          cloneElement(CurComponent, {}, chunks)
        )
    };
  }, {});

  return t.rich(i18nKey, customTags);
}
